import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ADMIN_TIER = ["admin", "super_admin"];
const STAFF_TIER = ["staff", "editor"];  // pure staff (not admin)

/**
 * Public-facing marketing / catalogue routes must NOT expose a website to
 * anonymous visitors on the production domain (carrentapp.brainart.gr is
 * strictly an API gateway). This gate sits at `/` and routes:
 *
 *   unauthenticated visitor    → /login
 *   authenticated admin        → /admin (full dashboard)
 *   authenticated staff/editor → /admin/bookings (their first allowed page)
 *   authenticated customer     → /dashboard
 *
 * Sending staff/editor to `/admin` (which is adminOnly) used to bounce
 * them back to `/`, creating an infinite navigate loop that fired
 * React's "Maximum update depth exceeded" warning. Routing them
 * straight to a role-accessible landing kills the loop.
 */
export default function RootGate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (ADMIN_TIER.includes(user.role)) {
    return <Navigate to="/admin" replace />;
  }
  if (STAFF_TIER.includes(user.role)) {
    return <Navigate to="/admin/bookings" replace />;
  }
  return <Navigate to="/dashboard" replace />;
}
